import type { Event, EventHint } from '@sentry/gatsby'

const isHeadlessBrowser = (event: Event) => {
  const headers = event.request?.headers
  const userAgent = headers?.['User-Agent'] || headers?.['user-agent']

  return userAgent?.toLowerCase().includes('headless') ?? false
}

export const beforeSend = (event: Event, hint?: EventHint): Event | null => {
  if (hint?.originalException === 'Timeout') return null
  if (isHeadlessBrowser(event)) return null

  if (event.message && /GQL Operation Failed/i.test(event.message)) {
    return { ...event, fingerprint: [event.message] }
  }

  return event
}

export const ignoreErrors: string[] = ['Invalid state']
